import React from "react";
import Select from "react-select";
import { MEDIA_BASE_URL } from "../../../Config/BaseUrl";
import pic1 from "../../../assets/images/dummy.png";
import { convertDate } from "../../CommonComponent/DateFormatUtil";
const TeacherProfile = ({ schoolInfo, teacher_detail }) => {
  const {
    organization_name,
    school_name,
    udise_no,
    contact_person,
    contact_number,
    contact_email,

    state,
    city,
    pincode,
    status,
    is_government,
    school_logo,
    module,
  } = schoolInfo;

  const {
    profile_pic,
    teacher_name,
    employ_code,
    dob,
    email,
    mobile,
    qualification,
    teaching_classes,
    address,
  } = teacher_detail[0];

  let data = [
    {
      profile_pic: "",
      school_name: "Tirpude Junior College",
      teacher_name: "Live Teacher",
      employ_code: "TEMM00012",
      dob: "2000-06-30",
      email: "dabeta7889@bawsny.com",
      mobile: "4444444444",
      qualification: "M.tech",
      address: "nagpur",
      teaching_classes: [
        {
          id: 1625,
          class_name: "10 th",
          section: "B",
          subject: "English",
          medium: "English",
          active_status: true,
          class_teacher: true,
        },
        {
          id: 1626,
          class_name: "10 th",
          section: "B",
          subject: "Hindi",
          medium: "English",
          active_status: true,
          class_teacher: true,
        },
        {
          id: 1627,
          class_name: "10 th",
          section: "B",
          subject: "Marathi",
          medium: "English",
          active_status: true,
          class_teacher: true,
        },
        {
          id: 1628,
          class_name: "10 th",
          section: "B",
          subject: "Science",
          medium: "English",
          active_status: true,
          class_teacher: true,
        },
      ],
    },
  ];

  return (
    <div>
      <div className="section-body">
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center ">
            <div className="header-action">
              <h1 className="page-title">Personal Information</h1>
            </div>
            <ul className="nav nav-tabs page-header-tab"></ul>
          </div>
        </div>
      </div>
      <div className="section-body mt-4">
        <div className="container-fluid">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-8">
                  <div className="form-group row">
                    <label className="col-md-3 col-form-label">
                      Name
                      <span className="text-danger"></span>
                    </label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter School Name"
                        name="name"
                        value={teacher_name}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-md-3 col-form-label">
                      Qualification
                      <span className="text-danger"></span>
                    </label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter School Name"
                        name="name"
                        value={qualification}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      className="col-md-3 col-form-label"
                      htmlFor="udisnumber"
                    >
                      Employ Code
                      <span className="text-danger"></span>
                    </label>
                    <div className="col-md-9">
                      <input
                        id="udisnumber"
                        type="text"
                        className="form-control"
                        placeholder="Please Enter U-DISE Number"
                        name="udise_no"
                        value={employ_code}
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-md-3 col-form-label">
                      Date Of Birth
                      <span className="text-danger"></span>
                    </label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Address"
                        name="address"
                        value={convertDate(dob)}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-md-3 col-form-label">
                      Email <span className="text-danger"></span>
                    </label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Address"
                        name="address"
                        value={email}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-md-3 col-form-label">
                      Mobile <span className="text-danger"></span>
                    </label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Address"
                        name="address"
                        value={mobile}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label className="col-md-3 col-form-label">
                      Address <span className="text-danger"></span>
                    </label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Pincode"
                        name="pincode"
                        value={address}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="section-body">
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center ">
            <div className="header-action">
              <h1 className="page-title">Teaching Classes</h1>
            </div>
            <ul className="nav nav-tabs page-header-tab"></ul>
          </div>
        </div>
      </div>
      <div className="section-body mt-4">
        <div className="container-fluid">
          <div className="card">
            <div className="card-body">
              <table className="table table-bordered table-striped table-hover">
                <thead className="table-dark">
                  <tr>
                    <th>Class Section</th>

                    <th>Subject</th>

                    <th>Class Teacher</th>
                  </tr>
                </thead>
                <tbody>
                  {teaching_classes?.map((item) => (
                    <tr key={item.id}>
                      <td>
                        {item.class_name} {item.section}
                      </td>

                      <td>{item.subject}</td>

                      <td>{item.class_teacher ? "Yes" : "No"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {/* create a table to map the content of teaching_classes in bootstrap*/}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeacherProfile;
